// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hub-tournament-matches-dates__container {
    display: flex;
    align-content: center;
    justify-content: center;
    /* gap: 8px; */
    background: var(--white-color);
    /* padding: 12px 16px; */
    margin-bottom: 16px;
    border-radius: 6px;
    border: 1px solid var(--new-gray-background-color);
}

.hub-tournament-matches-dates__dates-container {
    display: flex;
    align-content: center;
    /* justify-content: center; */
    gap: 8px;
    padding: 12px 16px;
    width: 100%;
    /* background: var(--white-color);
    padding: 12px 16px;
    margin-bottom: 16px; */

    position: relative;
    overflow-x: hidden;
    scroll-snap-type: x mandatory;
    scroll-behavior: smooth;
    overflow-y: hidden;
}

.hub-tournament-matches-dates__date {
    border-radius: 25px;
    border: 1px solid var(--primary-dark-color);
    padding: 8px 16px;
    background: var(--white-color);
    cursor: pointer;
    text-wrap: nowrap;        
    min-width: 85px;
    text-align: center;
}

.hub-tournament-matches-dates__date.baloa-table {
    color: var(--primary-dark-color);
}

.hub-tournament-matches-dates__date.selected{
    border: 1px solid var(--new-green-color);
    background: #EAF7F0;
}

.hub-tournament-matches-dates__date.baloa-table.selected {
    color: var(--new-green-color);
}

.hub-tournament-matches-dates__arrow {
    position: relative;
    /* top: 53%; */
    cursor: pointer;
    z-index: 9;
    border-radius: 50%;
}

.hub-tournament-matches-dates__arrow.next .hubicon-arrow_circle_right, 
.hub-tournament-matches-dates__arrow.prev .hubicon-arrow_circle_left {
    font-size: 22px;
}


.hub-tournament-matches-dates__arrow.prev {
    left: -18px;
    top: 20px;
    margin-right: -28px;
}

.hub-tournament-matches-dates__arrow.next {
    right: 10px;
    top: 20px;
    margin-right: -28px;
}

@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */

    .hub-tournament-matches-dates__date {
        padding: 4px 8px;
        min-width: 50px;
    }

    .hub-tournament-matches-dates__dates-container {
        overflow-x: scroll;
    }
}`, "",{"version":3,"sources":["webpack://./src/app/tournaments/components/hub-tournament-matches-dates/HubTournamentMatchesDatesComponent.styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;IACd,8BAA8B;IAC9B,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,6BAA6B;IAC7B,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX;;0BAEsB;;IAEtB,kBAAkB;IAClB,kBAAkB;IAClB,6BAA6B;IAC7B,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,iBAAiB;IACjB,8BAA8B;IAC9B,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,wCAAwC;IACxC,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,UAAU;IACV,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;AACnB;;;AAGA;IACI,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,mBAAmB;AACvB;;AAEA,yCAAyC,4BAA4B;;IAEjE;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ","sourcesContent":[".hub-tournament-matches-dates__container {\n    display: flex;\n    align-content: center;\n    justify-content: center;\n    /* gap: 8px; */\n    background: var(--white-color);\n    /* padding: 12px 16px; */\n    margin-bottom: 16px;\n    border-radius: 6px;\n    border: 1px solid var(--new-gray-background-color);\n}\n\n.hub-tournament-matches-dates__dates-container {\n    display: flex;\n    align-content: center;\n    /* justify-content: center; */\n    gap: 8px;\n    padding: 12px 16px;\n    width: 100%;\n    /* background: var(--white-color);\n    padding: 12px 16px;\n    margin-bottom: 16px; */\n\n    position: relative;\n    overflow-x: hidden;\n    scroll-snap-type: x mandatory;\n    scroll-behavior: smooth;\n    overflow-y: hidden;\n}\n\n.hub-tournament-matches-dates__date {\n    border-radius: 25px;\n    border: 1px solid var(--primary-dark-color);\n    padding: 8px 16px;\n    background: var(--white-color);\n    cursor: pointer;\n    text-wrap: nowrap;        \n    min-width: 85px;\n    text-align: center;\n}\n\n.hub-tournament-matches-dates__date.baloa-table {\n    color: var(--primary-dark-color);\n}\n\n.hub-tournament-matches-dates__date.selected{\n    border: 1px solid var(--new-green-color);\n    background: #EAF7F0;\n}\n\n.hub-tournament-matches-dates__date.baloa-table.selected {\n    color: var(--new-green-color);\n}\n\n.hub-tournament-matches-dates__arrow {\n    position: relative;\n    /* top: 53%; */\n    cursor: pointer;\n    z-index: 9;\n    border-radius: 50%;\n}\n\n.hub-tournament-matches-dates__arrow.next .hubicon-arrow_circle_right, \n.hub-tournament-matches-dates__arrow.prev .hubicon-arrow_circle_left {\n    font-size: 22px;\n}\n\n\n.hub-tournament-matches-dates__arrow.prev {\n    left: -18px;\n    top: 20px;\n    margin-right: -28px;\n}\n\n.hub-tournament-matches-dates__arrow.next {\n    right: 10px;\n    top: 20px;\n    margin-right: -28px;\n}\n\n@media screen and ( max-width: 440px ) { /* Cambio de 430px a 440px */\n\n    .hub-tournament-matches-dates__date {\n        padding: 4px 8px;\n        min-width: 50px;\n    }\n\n    .hub-tournament-matches-dates__dates-container {\n        overflow-x: scroll;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
